module.exports = __webpack_public_path__ + "static/media/Axew_gaussian2.3edbd0b8.png";